module.exports = __webpack_public_path__ + "img/BOTSOLO.fc17039b.png";